import axios      from 'axios';
import { Config } from './configActions';

var Authorization = {'Authorization': 'Bearer '+localStorage.getItem("jwtToken")}
 Config();	

export const FETCH_ID_ATIVIDADE     = 'FETCH_ID_ATIVIDADE';
export const FETCH_ATIVIDADES_LISTA = 'FETCH_ATIVIDADES_LISTA';
export const FETCH_DESEMPENHO_ALUNO = 'FETCH_DESEMPENHO_ALUNO';
export const FETCH_ALL_QUESTAO      = 'FETCH_ALL_QUESTAO';
export const FETCH_ALL_PALAVRA      = 'FETCH_ALL_PALAVRA';
export const ADD_QUESTAO            = 'ADD_QUESTAO';
export const ADD_PALAVRA            = 'ADD_PALAVRA';
export const UPDATE_QUESTAO         = 'UPDATE_QUESTAO';
export const UPDATE_PALAVRA         = 'UPDATE_PALAVRA';
export const UPDATE_UPLOAD_IMAGEM   = 'UPDATE_UPLOAD_IMAGEM';
export const REMOVE_ATIVIDADE       = 'REMOVE_ATIVIDADE';
export const REMOVE_PALAVRA         = 'REMOVE_PALAVRA';
export const REMOVE_QUESTAO         = 'REMOVE_QUESTAO';
export const ANULAR_ATIVIDADE       = 'ANULAR_ATIVIDADE';
export const CLOSE_MODAL            = 'CLOSE_MODAL';


// Inicio
export function GetAtividadesLista(usu_id,per_id) {
	    
    const request = axios.get(`/api/atividades/listar/${usu_id}/${per_id}`,Authorization);
    return{
			type    : FETCH_ATIVIDADES_LISTA,
			payload : request
	};

}

export function GetDesempendoAtividade(ati_id){
 
	const request = axios.get(`/api/atividades/desempenho/alunos/${ati_id}`,Authorization);
    return {
			type    : FETCH_DESEMPENHO_ALUNO,
			payload : request
          }
}

export function GetMissaoQuestao(que_id){
	
	   const request = axios.get(`/api/atividades/questoes/listar/${que_id}`,Authorization);
	   return {
			   type    : FETCH_ALL_QUESTAO,
			   payload : request
			 }
}

export function GetMissaoPalavra(que_id){
	
	   const request = axios.get(`/api/atividades/palavras/listar/${que_id}`,Authorization);
	   return {
			   type    : FETCH_ALL_PALAVRA,
			   payload : request
			 }
}

export function CloseModal(acao){
	
	 return {
		   type    : CLOSE_MODAL,
		   payload : acao
	  }
}

export function GetObterAtividade(ati_id){

	
	return dispatch =>{
		
		return axios.get(`/api/atividades/obter/${ati_id}`,Authorization);
	}

}

export function ExcluirImagemQuestao(id){
	return dispatch => {
	  return axios.get(`/api/atividades/questoes/delete/anexo/${id}`);
	}
}

//Fim

export function SetCadastroAtividades(retorno) {
    
	    	  const acao ={method:axios.post,rota:"/api/atividades/cadastrar"}; 
		      const rota = acao.rota;
			  const request =  acao.method(rota,
			                {
				                ati_cod_professor  : retorno.usu_id,
				                ati_data_inicio    : retorno.ati_data_inicio,
				                ati_data_fim       : retorno.ati_data_fim,
				                ati_titulo         : retorno.ati_titulo,
				                ati_tipo           : retorno.ati_tipo,
				                ati_qtd_tentativas : retorno.ati_qtd_tentativas,
				                ati_id             : retorno.ati_id,
				                disciplina_turma   : retorno.disciplina_turma
							 },
						Authorization);
						

	return {
		type    : FETCH_ID_ATIVIDADE,
		payload : request
     }

}

export function SetDuplicarAtividade(retorno) {
	return dispatch =>{
		
	    	  const acao ={method:axios.post,rota:"/api/atividades/duplicar"}; 
		      const rota = acao.rota;
			 	return  axios.post(rota,
			                {
				                ati_cod_professor  : retorno.usu_id,
				                ati_data_inicio    : retorno.ati_data_inicio,
				                ati_data_fim       : retorno.ati_data_fim,
				                ati_titulo         : retorno.ati_titulo,
				                ati_tipo           : retorno.ati_tipo,
				                ati_qtd_tentativas : retorno.ati_qtd_tentativas,
				                id_atv_pai         : retorno.ati_id,
								disciplina_turma   : retorno.disciplina_turma
							 },
						Authorization);
					}
}

export function SetEditarAtividades(retorno) {
    
	 return dispatch => {
	    	  const acao = {method:axios.post,rota:"/api/atividades/atualizar"}; 
		      const rota = acao.rota;
			  return acao.method(rota,
			                {
				              
				                ati_data_inicio    : retorno.ati_data_inicio,
				                ati_data_fim       : retorno.ati_data_fim,
				                ati_titulo         : retorno.ati_titulo,
				                ati_qtd_tentativas : retorno.ati_qtd_tentativas,
								ati_id             : retorno.ati_id
							 },
			            Authorization);
     }

}

export function SetExcluirAtividades(ati_id,use_id) {
	
	
	return dispatch => {
			return axios.get(`/api/atividades/deletar/${ati_id}/${use_id}`,Authorization);
	}

	// axios.get(`/api/atividades/deletar/${ati_id}/${use_id}`,Authorization);
    // return{
	// 	type    : REMOVE_ATIVIDADE,
	// 	payload : ati_id
	// }

}

export function SetAnularAtividades(ati_id,use_id){	
	return dispatch => {
		return axios.get(`/api/atividades/alterar/status/${ati_id}/${use_id}`,Authorization);
	}
	// const request = axios.get(`/api/atividades/alterar/status/${ati_id}/${use_id}`,Authorization);

    // return{
	// 	type    : ANULAR_ATIVIDADE,
	// 	payload : request
	// }

}

export function SetExcluirPalavra(pal_id){    
	axios.get(`/api/atividades/apagar/palavra/${pal_id}`,Authorization);
    return{
		type    : REMOVE_PALAVRA,
		payload : pal_id
	}
}

export function SetExcluirQuestao(que_id){    
	axios.get(`/api/atividades/apagar/quiz/${que_id}`,Authorization);
    return{
		type    : REMOVE_QUESTAO,
		payload : que_id
	}
}

export function SetCrudsQuestao(retorno,file){
	
	if (retorno.ati_que_id === 0) {
	
	    	//cadastro com upload
			if (file) {
				return dispatch => {
					const formData = new FormData();
					formData.append('ati_que_anexo',file[0]);
					formData.append('ati_que_cod_atividade',JSON.stringify(retorno.que_id));
					formData.append('ati_que_pergunta',retorno.ati_ati_per);
					formData.append('ati_que_opcao_a',retorno.ati_questao_a);
					formData.append('ati_que_opcao_b',retorno.ati_questao_b);
					formData.append('ati_que_opcao_c',retorno.ati_questao_c);
					formData.append('ati_que_opcao_d',retorno.ati_questao_d);
					formData.append('ati_que_contexto',retorno.ati_que_contexto);
					formData.append('ati_que_tempo',retorno.ati_que_tempo);
					formData.append('ati_que_resposta',retorno.ati_resposta);
					return axios.post('/api/atividades/cadastrar/quiz', formData,Authorization);
					// return{
					//     type    : ADD_QUESTAO,
					//     payload : request
					// };
				}
				
			} else {
				//cadastro sem upload	
				return dispatch => {
					return axios.post('api/atividades/cadastrar/quiz', {
					ati_que_anexo         : null,
					ati_que_cod_atividade : retorno.que_id,
					ati_que_pergunta      : retorno.ati_ati_per,
					ati_que_opcao_a       : retorno.ati_questao_a,
					ati_que_opcao_b       : retorno.ati_questao_b,
					ati_que_opcao_c       : retorno.ati_questao_c,
					ati_que_opcao_d       : retorno.ati_questao_d,
					ati_que_contexto      : retorno.ati_que_contexto,
					ati_que_tempo         : retorno.ati_que_tempo,
					ati_que_resposta      : retorno.ati_resposta
					},Authorization);
					// return {
					// 		type    : ADD_QUESTAO,
					// 		payload : request
					// 	   }
				}
			}
		
	} else {

			//Edicao com upload
			if (file) {
				return dispatch => {
					const formData = new FormData();
					formData.append('ati_que_anexo',file[0]);
					formData.append('ati_que_cod_atividade',retorno.que_id);
					formData.append('ati_que_id',retorno.ati_que_id);
					formData.append('ati_que_pergunta',retorno.ati_ati_per);
					formData.append('ati_que_opcao_a',retorno.ati_questao_a);
					formData.append('ati_que_opcao_b',retorno.ati_questao_b);
					formData.append('ati_que_opcao_c',retorno.ati_questao_c);
					formData.append('ati_que_opcao_d',retorno.ati_questao_d);
					formData.append('ati_que_contexto',retorno.ati_que_contexto);
					formData.append('ati_que_tempo',retorno.ati_que_tempo);
					formData.append('ati_que_resposta',retorno.ati_resposta);
					return  axios.post('/api/atividades/atualizar/questao', formData,Authorization);
                // return{
                //     type    : UPDATE_QUESTAO,
                //     payload : request
				// };
		    	}
				
			} else {
				//Edicao sem upload	
				return dispatch => {
				return axios.post('api/atividades/atualizar/questao', {
				ati_que_id            : retorno.ati_que_id,
				ati_que_anexo         : null,
				ati_que_cod_atividade : retorno.que_id,
				ati_que_pergunta      : retorno.ati_ati_per,
				ati_que_opcao_a       : retorno.ati_questao_a,
				ati_que_opcao_b       : retorno.ati_questao_b,
				ati_que_opcao_c       : retorno.ati_questao_c,
				ati_que_opcao_d       : retorno.ati_questao_d,
				ati_que_contexto      : retorno.ati_que_contexto,
				ati_que_tempo         : retorno.ati_que_tempo,
				ati_que_resposta      : retorno.ati_resposta
				},Authorization);
				// return {
				// type    : UPDATE_QUESTAO,
				// payload : request
				// }	
			   }
			}
	}
}

export function SetCrudsPalavra(retorno){
	return dispatch => {
	const acao = (retorno.ati_pal_id === 0
		? {
						method: axios.post,
						rota: "api/atividades/cadastrar/palavra"
		}
		: {
						method: axios.post,
						rota: "api/atividades/atualizar/palavra"
		});

		const rota    = acao.rota;
		return acao.method(rota, {
							ati_pal_id            : retorno.ati_pal_id,
							ati_pal_cod_atividade : retorno.pal_id,
							ati_pal_pergunta      : retorno.ati_per,
							ati_pal_tempo         : retorno.ati_pal_tempo,
							ati_pal_contexto      : retorno.ati_pal_contexto,
							ati_pal_palavra       : retorno.ati_pal
					},
					Authorization);
	}				
	// return {
	// 		 type    : ( retorno.ati_pal_id === 0 ? ADD_PALAVRA : UPDATE_PALAVRA ),
	// 		 payload : request
	// 		}

}

export function SetEditarQuestao(retorno){	 
	 return dispatch => {
		 	const rotas = (retorno.tipo === 0? "/api/atividades/atualizar/questao": "/api/atividades/atualizar/palavra")
			return axios.post(rotas,retorno,
			Authorization);
    }
}

export function SetDadosAtividadesPalChave(retorno){
	 return dispatch =>{		 
		return axios.post('/api/atividades/responder',
			{
				ati_res_cod_aluno:retorno.use_id,
				ati_res_cod_atividade:retorno.ati_id,
				ati_res_resposta:retorno.res_pal_chave,
				ati_res_pontuacao:0,
				ati_tipo:retorno.ati_tipo
			},
		Authorization);
    }
}	

export function GetEditarAtividades(ati_id){
    return dispatch => {
        return axios.get(`/api/atividades/obter/${ati_id}`);
    }
}

export function getDadosAtividades(ati_id,ati_tipo){
	return dispatch =>{
		return axios.get(`/api/atividades/carregar/${ati_id}/${ati_tipo}`);
	}
}	

export function ValidacaoPage(per_id){

	  if (per_id!==2) {
                    
            alert('Você não tem permissão para acessar essa página.');
            window.location = '/';            
         }

}

export function GetTipoAtividade(tipo){

	return dispatch =>{

		var retorno = {}
		switch (tipo) {
			case "forca": 
			  retorno.tipo =  "Desarmando Bomba";
			break;      
			case "palavrachave":
			  retorno.tipo =  "Código de Acesso";
			break;     
			case "quiz":
			  retorno.tipo =  "Roda do Destino";
			break;     
			default:
		   break;   
		}
		return retorno.tipo;

	}

}


// export function SetUploadFiles(ati_que_id,file) {
	
// 		return dispatch => {
// 				return axios.all(
// 						ati_que_id.map((elem,i)=>{
// 						const formData = new FormData();
// 						formData.append('ati_que_anexo', file[0]);
// 						formData.append('ati_que_id', elem);
// 						return 	axios.post('/api/atividades/questoes/upload', formData, Authorization);
// 					})
// 				)
// 		}
			
// }


// WEBPACK FOOTER //
// ./src/actions/atividadesAction.js